{
  "custom_objects": {
    "import_error": "Import Error"
  },
  "grid": {
    "workspace_columns": "Workspace Columns"
  },
  "schema": {
    "manage_columns": "Manage Columns",
    "field_name": "Field Name",
    "type": "Type",
    "options": "Options",
    "action": "Action"
  },
  "fields": {
    "no_custom_fields_to_edit": "No custom fields to edit",
    "edit_custom_fields": "Edit custom fields",
    "field_name": "Field Name",
    "options": "Options",
    "update_list_name": "Update list name",
    "placeholder_default": "Name",
    "type_options_placeholder": "Type options",
    "type_or_paste_options": "Type or paste options with comma delimit...",
    "validation": {
      "enter_name": "please enter a name",
      "enter_value": "please enter a value"
    }
  },
  "status": {
    "loading_data": "Loading data",
    "updated": "Updated!"
  },
  "accessibility": {
    "drag_option": "drag option",
    "remove_option": "remove option"
  }
}
